import PublicTrackingPage from '@/features/worksites/components/public-tracking-page';
import { createFileRoute } from '@tanstack/react-router';

// Hors `_app` : la page ne porte ni shell, ni session — le destinataire est
// le client final, il n'a pas de compte.
export const Route = createFileRoute('/suivi/$token')({
  component: PublicTrackingPage,
});
